var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.rootTag,_vm._b({ref:"rootEl",tag:"component",class:( _obj = {}, _obj[_vm.css.boxList] = true, _obj[_vm.css.isRelatedList] = _vm.isRelatedList, _obj[_vm.css.isOrderedList] = _vm.box.data && _vm.box.data.style === 'ordered', _obj )},'component',_vm.schemaDisabled ? '': {
    itemprop: 'articleBody',
  },false),_vm._l((_vm.items),function(item,key){return _c('li',{key:key},[_c(item.component,_vm._b({tag:"component",domProps:{"innerHTML":_vm._s(item.text)}},'component',item.attrs,false))],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }